import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Spinner, Table, Button } from 'react-bootstrap';
import { FaCogs, FaSave, FaFileAlt } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import impresionTicketApi from '../../../services/api/impresionTicketApi';

const MantenimientoEstructuraTicket = () => {
  const [secciones, setSecciones] = useState([]);
  const [loadingSecciones, setLoadingSecciones] = useState(false);
  const [savingSecciones, setSavingSecciones] = useState(false);
  const [tiposSecciones, setTiposSecciones] = useState([]);
  const [ticketInfo, setTicketInfo] = useState(null);

  const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

  const fetchSecciones = async () => {
    if (!selectedProject || !selectedProject.id) return;
    setLoadingSecciones(true);
    try {
        const res = await impresionTicketApi.getSecciones(selectedProject.id);
        if (res.data.success) {
            setTicketInfo(res.data.data.ticket_info);
            setSecciones(res.data.data.secciones);
            setTiposSecciones(res.data.data.tipos_secciones);
        }
    } catch (e) {
        toast.error("Error cargando configuración de ticket");
    } finally {
        setLoadingSecciones(false);
    }
  };

  useEffect(() => {
    if (selectedProject && selectedProject.id) {
        fetchSecciones();
    }
  }, [selectedProject?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSeccionChange = (index, field, value) => {
    const newSecciones = [...secciones];
    if (field === 'posicion') value = parseInt(value, 10) || 1;
    if (field === 'impresion_tipo_secciones_id') {
      value = parseInt(value, 10);
      const tipoSel = tiposSecciones.find(t => t.id === value);
      if (tipoSel) {
        newSecciones[index].tipo_codigo = tipoSel.codigo;
      }
    }
    
    newSecciones[index][field] = value;
    setSecciones(newSecciones);
  };

  const handleUpdateSecciones = async () => {
    if (!selectedProject || !selectedProject.id) return;
    
    const activeSecciones = secciones.filter(s => s.activo === 1);
    const posMap = {};
    for (let sec of activeSecciones) {
        const key = `${sec.impresion_tipo_secciones_id}_${sec.posicion}`;
        if (posMap[key]) {
            const code = tiposSecciones.find(t => t.id === sec.impresion_tipo_secciones_id)?.codigo || 'desconocida';
            toast.warning(`No puedes tener dos elementos en la posición ${sec.posicion} para el tipo de sección ${code}`);
            return;
        }
        posMap[key] = true;
    }

    setSavingSecciones(true);
    try {
        const res = await impresionTicketApi.updateSecciones(selectedProject.id, secciones);
        if (res.data.success) {
            toast.success("Estructura de ticket actualizada correctamente");
            fetchSecciones(); // Refrescar la tabla
        } else {
            toast.error("Error al actualizar la estructura");
        }
    } catch (e) {
        toast.error("Error de conexión al actualizar la estructura");
    } finally {
        setSavingSecciones(false);
    }
  };

  if (!selectedProject || !selectedProject.id) {
    return (
      <Container fluid className="p-4 pt-5">
        <Card className="shadow-sm border-0 rounded-4">
          <Card.Body className="p-5 text-center">
            <h4 className="text-muted">Por favor, seleccione un proyecto en el menú superior para configurar su ticket.</h4>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  return (
    <Container fluid className="p-4 pt-5">
      <ToastContainer position="top-right" autoClose={3000} />
      
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1 text-primary fw-bold" style={{ fontSize: '1.8rem' }}>
            <FaFileAlt className="me-2 text-secondary" /> 
            Estructura Impresión Ticket
          </h2>
          <p className="text-muted mb-0">Parametriza el diseño dinámico de los tickets impresos por proyecto.</p>
        </div>
      </div>

      <Card className="shadow-sm border-0 rounded-4">
        <Card.Body className="p-4">
          <div className="py-2 px-md-4 d-flex justify-content-center">
            {loadingSecciones ? (
                <div className="text-center py-4 w-100"><Spinner animation="border" variant="primary" /> <p className="mt-2 text-muted">Cargando diseño...</p></div>
            ) : (
                <div className="table-responsive col-12 col-xl-10 col-xxl-9">
                    {ticketInfo && (
                        <div className="mb-3 d-flex align-items-center bg-light border rounded p-3 shadow-sm">
                            <div className="fw-bold text-primary pe-3 border-end me-3" style={{ fontSize: '1.1rem' }}>
                                {ticketInfo.codigo}
                            </div>
                            <div className="fw-semibold text-secondary">
                                {ticketInfo.descripcion}
                            </div>
                        </div>
                    )}
                    <Table hover responsive className="align-middle border shadow-sm rounded overflow-hidden">
                    <thead className="table-light">
                        <tr>
                        <th className="text-center pt-3 pb-3">Tipo Sección</th>
                        <th className="text-center pt-3 pb-3">Descripción (Leyenda)</th>
                        <th className="text-center pt-3 pb-3" style={{width: '90px'}}>Posición</th>
                        <th className="text-center pt-3 pb-3">Nombre Campo</th>
                        <th className="text-center pt-3 pb-3" style={{width: '90px'}}>Activo</th>
                        </tr>
                    </thead>
                    <tbody className="border-top-0">
                        {secciones.map((sec, idx) => {
                        const isTitleSection = sec.tipo_codigo && (sec.tipo_codigo === "TIT" || sec.tipo_codigo === "SUB-T" || sec.tipo_codigo === "PIE-P");
                        const rowClass = isTitleSection ? "table-warning" : "table-success";
                        const opacityClass = sec.activo === 0 ? 'opacity-50' : '';
                        
                        const allowedToChangeType = sec.tipo_codigo && sec.tipo_codigo.startsWith("SEC-");
                        const availableTypes = allowedToChangeType 
                            ? tiposSecciones.filter(t => t.codigo.startsWith("SEC-"))
                            : tiposSecciones.filter(t => t.id === sec.impresion_tipo_secciones_id);

                        return (
                        <tr key={sec.id} className={`${rowClass} ${opacityClass}`}>
                            <td>
                            <Form.Select 
                                size="sm"
                                value={sec.impresion_tipo_secciones_id}
                                onChange={(e) => handleSeccionChange(idx, 'impresion_tipo_secciones_id', e.target.value)}
                                className="fw-bold shadow-none"
                                disabled={!allowedToChangeType}
                            >
                                {availableTypes.map(tipo => (
                                    <option key={tipo.id} value={tipo.id}>{tipo.descripcion}</option>
                                ))}
                            </Form.Select>
                            </td>
                            <td>
                            <Form.Control 
                                type="text" 
                                size="sm"
                                value={sec.descripcion} 
                                onChange={(e) => handleSeccionChange(idx, 'descripcion', e.target.value)} 
                                className="shadow-none border-1"
                            />
                            </td>
                            <td className="text-center">
                            <Form.Control 
                                type="number" 
                                size="sm"
                                className="text-center fw-bold text-primary shadow-none border-1"
                                value={sec.posicion} 
                                min="1"
                                onChange={(e) => handleSeccionChange(idx, 'posicion', e.target.value)}
                            />
                            </td>
                            <td className="text-center">
                            <span className={`badge ${sec.nombre_campo ? 'bg-secondary' : 'bg-light text-muted border'} px-3 py-2 rounded-pill`}>
                                {sec.nombre_campo || 'N/A (Estático)'}
                            </span>
                            </td>
                            <td className="text-center">
                            <Form.Check 
                                type="switch"
                                id={`switch-${sec.id}`}
                                className="d-flex justify-content-center"
                                checked={sec.activo === 1}
                                onChange={(e) => handleSeccionChange(idx, 'activo', e.target.checked ? 1 : 0)}
                            />
                            </td>
                        </tr>
                        );
                        })}
                    </tbody>
                    </Table> 
                    <div className="d-flex justify-content-between align-items-center mt-3 pt-3">
                    <span className="text-danger small fw-semibold">
                        * El presente menú NO permite crear nuevas secciones o contenido, de necesitar vincular nuevos campos a Base de Datos debe contactar con el soporte.
                    </span>
                    <Button variant="success" className="btn-dh-primary text-nowrap px-4" onClick={handleUpdateSecciones} disabled={savingSecciones}>
                        {savingSecciones ? <Spinner animation="border" size="sm" className="me-2" /> : <FaSave className="me-2" />}
                        {savingSecciones ? 'Guardando...' : 'Guardar Cambios'}
                    </Button>
                    </div>
                </div>
            )}
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default MantenimientoEstructuraTicket;
